var map = {
	"./1.png": 1451,
	"./2.png": 160,
	"./3.png": 6409,
	"./4.png": 7014,
	"./CFER Foundation.png": 4735,
	"./ParentDiscussion.png": 9956,
	"./ParentSummaries.png": 5438,
	"./ParentTopics.png": 7320,
	"./ParentVoting.png": 1677,
	"./adit.png": 7488,
	"./bert.png": 9501,
	"./dashboard.png": 6318,
	"./discussion.png": 636,
	"./discussionP.png": 7190,
	"./downvote.png": 1696,
	"./drew.png": 6002,
	"./elections.png": 4910,
	"./gleb.png": 4836,
	"./logo.png": 3153,
	"./logo1.png": 3660,
	"./logo2.png": 4343,
	"./logo4.png": 3121,
	"./logo5.png": 4728,
	"./logo6.png": 3059,
	"./logo7.png": 6874,
	"./search.png": 1060,
	"./share.png": 1463,
	"./shareIcon.png": 9204,
	"./summaries.png": 8070,
	"./topics.png": 9232,
	"./town-image-2.png": 6101,
	"./town-image-3.png": 3836,
	"./town-image.png": 7600,
	"./upvote.png": 4291,
	"./user-icon.png": 983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;